






























































































import { Vue, Component } from 'vue-property-decorator'
import User from "@/classes/User";
import Axios, { AxiosResponse, AxiosError } from "axios";
import HeaderFieldConstant from '@/classes/helpers/HeaderFieldConstant';
import HeaderField from '@/classes/HeaderField';
import HIVETextField from "@/components/common/HIVETextField.vue";
import { QueryType } from '@/classes/enums/QueryType';
import { UserStatus } from '@/classes/enums/UserStatus';

@Component({
  components: {
        HIVETextField
  }
})
export default class Users extends Vue {    
      private user: User = new User();
    private headers: Array<HeaderField> = [
    new HeaderField("Action", "actions"),
    new HeaderField(HeaderFieldConstant.Name, "displayName"),
    new HeaderField(HeaderFieldConstant.Email, HeaderFieldConstant.email),
    new HeaderField(HeaderFieldConstant.Organization, "organization.name"),
    new HeaderField("Status", "status.displayName"),
    new HeaderField(
      HeaderFieldConstant.CreatedAt,
      HeaderFieldConstant.createdAt
    ),
    new HeaderField(
      HeaderFieldConstant.UpdatedAt,
      HeaderFieldConstant.updatedAt
    )];
    
    private expanded: Array<any> = [];
    private footerProps: object = {
    "items-per-page-options": [25, 50, 100],
  };
    private search: string = "";
    private users: Array<User> = new Array<User>();
      private queryType: QueryType | null = null;
      private queryTypeOptions: Array<string> = Object.values(QueryType);
      private userStatus: UserStatus | null = null;
      private userStatusOptions: Array<{ text: string; value: UserStatus }> = Object.keys(UserStatus)
        .filter((key) => isNaN(Number(key)))
        .map((key) => ({
          text: key,
          value: UserStatus[key as keyof typeof UserStatus],
        }));
    private get allUsers() {
        return this.$store.getters["users/getAllUsers"];
    }
    private get getIsAllUsersLoading() {
        return this.$store.getters["users/getIsAllUsersLoading"];
    }
    private get usersPagination() {
        return this.$store.getters["users/getAllUsersPagination"];
    }
    private get allUserCount() {
        return this.$store.getters["users/getAllUserCount"];
    }

    private get canSearch() {
      return (
        (this.search && this.search.trim().length > 0) ||
        this.userStatus != null
      );
    }

    private searchUsers() {
      const payload: any = {};
      if (this.search && this.search.trim().length > 0) {
        payload.query = this.search;
      }
      if (this.queryType) {
        payload.queryType = this.queryType;
      }
      if (this.userStatus != null) {
        payload.status = this.userStatus;
      }
      payload.page = 1;
      this.$store.dispatch("users/getAllUsers", payload);
    }

      private toggleExpand(item: any) {
        console.log("Toggling expand for item:", item);
        const idx = this.expanded.findIndex((e: any) => (e && e.id ? e.id : e) === item.id);
        if (idx === -1) {
          this.expanded.push(item);
        } else {
          this.expanded.splice(idx, 1);
        }
        console.log("expanded now", this.expanded);
      }

      private isExpanded(item: any) {
        const id = item.id;
        return this.expanded.some((e: any) => (e && e.id ? e.id : e) === id);
      }

    private paginate(e: any) {
    const options = e || {};
    const payload: any = {
      sortBy: options.sortBy && options.sortBy.length ? options.sortBy[0] : undefined,
      sortDesc: options.sortDesc && options.sortDesc.length ? options.sortDesc[0] : undefined,
      page: options.page,
      pageSize: options.itemsPerPage,
    };

    if (this.search && this.search.trim().length > 0) {
      payload.query = this.search;
    }

    if (this.queryType) {
      payload.queryType = this.queryType;
    }

    if (this.userStatus != null) {
      payload.status = this.userStatus;
    }

    this.$store.dispatch("users/getAllUsers", payload);
  }

}
